export const SearchProductInputComponent = {
  templateUrl:
    './app/ajs/_shared/components/search-product-input/search-product-input.component.html',
  bindings: {
    product: '<',
    productSelected: '&',
    productValidated: '&',
    productCleared: '&',
    placeholder: '<',
    disabled: '<',
  },
  controller: SearchProductInputController,
  controllerAs: 'vm',
};

SearchProductInputController.$inject = ['ProductService'];

function SearchProductInputController(ProductService) {
  const vm = this;

  // public methods
  // -----------------------
  vm.searchProduct = function (search) {
    if (search.length < 2) return;

    const params = {
      // get: 'active',
      value: search,
      skip_check_role: true,
    };

    return ProductService.searchProducts(params).then(function (data) {
      if (data.length === 0) {
        vm.productCleared();
      }

      return data;
    });
  };

  vm.selectProduct = function (product) {
    // console.log('selectproduct');
    // console.log(product);
    vm.productSelected({ $event: product });
  };

  vm.validateProduct = function () {
    // console.log('validateProduct');
    // console.log(vm.product);
    vm.productValidated({ $event: vm.product });
  };

  vm.clearProduct = function () {
    // console.log('clearProduct');
    // vm.product = null;

    vm.productCleared();
  };
}
